module.exports = __webpack_public_path__ + "static/media/11.eb915940.jpg";